
import React from 'react';
import { Link } from 'react-router-dom';

const Collections: React.FC = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      {/* Header de la Sección */}
      <section className="pt-20 pb-10 px-4 md:px-10 max-w-[1400px] mx-auto w-full text-center">
        <h1 className="text-4xl sm:text-6xl md:text-8xl font-black uppercase italic tracking-tighter leading-none">Nuestras <br/>Líneas</h1>
      </section>

      {/* Grid de Colecciones */}
      <section className="flex flex-col lg:flex-row w-full h-auto lg:h-[80vh]">
        {/* Colección MINIMAL */}
        <div className="relative h-[60vh] lg:h-auto flex-1 group overflow-hidden border-b lg:border-b-0 lg:border-r border-white/10">
          <div 
            className="absolute inset-0 bg-cover bg-[center_90%] transition-transform duration-[2s] group-hover:scale-110 grayscale" 
            style={{ backgroundImage: "url('/minimal.png')" }}
          ></div>
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500"></div>
          <div className="relative h-full flex flex-col items-center justify-center lg:justify-end lg:pb-20 px-6 md:px-10 text-center gap-4 md:gap-6">
            <h2 className="text-white text-4xl sm:text-6xl md:text-8xl font-black italic uppercase tracking-tighter leading-none drop-shadow-2xl">Minimal</h2>
            <p className="text-gray-300 max-w-sm font-medium tracking-wide">
              La esencia del motor. Siluetas limpias, materiales premium y branding sutil para los que hablan sin gritar.
            </p>
            <Link 
              to="/shop?collection=MINIMAL" 
              className="bg-white text-black px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs italic hover:bg-primary hover:text-white transition-all transform hover:scale-105"
            >
              Explorar Minimal
            </Link>
          </div>
        </div>

        {/* Colección GRAPHIC */}
        <div className="relative h-[60vh] lg:h-auto flex-1 group overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-[center_20%] transition-transform duration-[2s] group-hover:scale-110 grayscale brightness-75" 
            style={{ backgroundImage: "url('/graphic.png')" }}
          ></div>
          <div className="absolute inset-0 bg-primary/20 mix-blend-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500"></div>
          <div className="relative h-full flex flex-col items-center justify-center lg:justify-end lg:pb-20 px-6 md:px-10 text-center gap-4 md:gap-6">
            <h2 className="text-white text-4xl sm:text-6xl md:text-8xl font-black italic uppercase tracking-tighter leading-none drop-shadow-2xl">Graphic</h2>
            <p className="text-gray-300 max-w-sm font-medium tracking-wide">
              El coche como protagonista, representado de perfil con una gráfica precisa y elegante.
            </p>
            <Link 
              to="/shop?collection=GRAPHIC" 
              className="bg-white text-black px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs italic hover:bg-primary hover:text-white transition-all transform hover:scale-105"
            >
              Explorar Graphic
            </Link>
          </div>
        </div>
      </section>

      {/* Colección Destacada Inferior (SANAN) */}
      <section className="relative w-full h-[60vh] lg:h-[65vh] group overflow-hidden border-t border-white/10">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-[2s] group-hover:scale-105 grayscale brightness-75" 
          style={{ backgroundImage: "url('/sanan.png')" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
        
        <div className="relative h-full flex flex-col items-center justify-center px-6 md:px-10 text-center gap-6">
          <h2 className="text-white text-4xl sm:text-6xl md:text-8xl font-black italic uppercase tracking-tighter leading-none drop-shadow-2xl">SANAN</h2>
          <p className="text-gray-300 max-w-sm font-medium tracking-wide">
            Colección oficial de la temporada 2025 de Jordi San Andrés en el Desafío Peugeot.
          </p>
          <Link 
            to="/shop?collection=SANAN" 
            className="bg-white text-black px-10 py-4 rounded-xl font-black uppercase tracking-widest text-xs italic hover:bg-primary hover:text-white transition-all transform hover:scale-105"
            >
            Explorar SANAN
          </Link>
        </div>
      </section>

      {/* Sección Inferior - Filosofía */}
      <section className="bg-white py-32 px-4 md:px-10 border-t border-gray-100">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-16">
          <div className="space-y-4">
             <span className="text-primary text-4xl material-symbols-outlined">palette</span>
             <h4 className="font-black uppercase italic text-xl">Para todos los gustos</h4>
             <p className="text-gray-500 text-sm leading-relaxed">Encuentra tu esencia en cada diseño.</p>
          </div>
          <div className="space-y-4">
             <span className="text-primary text-4xl material-symbols-outlined">texture</span>
             <h4 className="font-black uppercase italic text-xl">Materiales PREMIUM</h4>
             <p className="text-gray-500 text-sm leading-relaxed">Solo utilizamos materiales PREMIUM, de alta calidad y resisténcia.</p>
          </div>
          <div className="space-y-4">
             <span className="text-primary text-4xl material-symbols-outlined">speed</span>
             <h4 className="font-black uppercase italic text-xl">Envío Fast-Track</h4>
             <p className="text-gray-500 text-sm leading-relaxed">Logística optimizada para que tu paquete llegue a casa lo antes posible.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Collections;
